<template>
  <AdmPanel>
    <h2 slot="header_title">{{ isAudit ? "榜单指标数据" : "数据管理"}}</h2>
    <div slot="header_buttons" class="adm-buttons">
        <iv-button ghost type="primary" @click="deliveryModel.shown=true">
          <iv-icon type="md-swap" />
          <span> CSR数据传递</span>
        </iv-button>
        <iv-button v-if="isAudit" type="primary" ghost @click="auditBatchTargetModal.shown=true">
          <iv-icon type="md-flash" />
          <span> 批量终审</span>
        </iv-button>
        <!-- 导出 -->
        <iv-button v-rbac-allow.hidden="['carbonTargetData', 'export']" :loading="loader[TARGET_DATA]"
          :disabled="loader[REPORT_DATA]" type="primary" class="export-excel-btn" @click="exportExcel()">
          <iv-icon type="ios-filing-outline" />
          <span> 导出</span>
        </iv-button>
    </div>
    <FilterBar slot="tools" :value="conditions" :condition="options.filter_rules">
      <span class="adm-buttons">
        <iv-button :disabled="loader[REPORT_DATA]" type="info" @click="changeQuery(mergeQuery({ ...conditions }))"> <iv-icon type="md-search" size="14" style="vertical-align:text-bottom" /> 查询 </iv-button>
      </span>
    </FilterBar>
    <div class="adm-panel__tools">
      <span style="width:6em;text-align: right;display: inline-block;">一级指标：</span>
      <iv-select
        v-model="conditions.firstTargetNum"
        filterable
        clearable
        style="width:120px"
        placeholder="一级指标"
        @on-change="
          changeQuery({ ...conditions, offset: 0 });
          conditions.secondTargetNum = '';
          conditions.thirdTargetNum='';
        "
      >
        <iv-option v-for="(item, index) in options.firstTargets" :value="item.id" :key="index">{{ item.name }}</iv-option>
      </iv-select>
    </div>
    <div class="adm-panel__tools">
      <span style="width:6em;text-align: right;display: inline-block;">二级指标：</span>
      <iv-select v-model="conditions.secondTargetNum" filterable clearable style="width:300px;" placeholder="二级指标"
        @on-change="changeQuery({ ...conditions, offset: 0 });conditions.thirdTargetNum=''">
        <iv-option v-for="(item, key) in options.secondTargets" :value="item.id" :key="item.id + key">{{ item.name }}</iv-option>
      </iv-select>
    </div>
    <div class="adm-panel__tools">
      <span style="width:6em;text-align: right;display: inline-block;">三级指标：</span>
      <iv-select v-model="conditions.thirdTargetNum" filterable clearable style="width:300px;" placeholder="三级指标"
        @on-change="changeQuery({ ...conditions, offset: 0 })">
        <iv-option v-for="(item, key) in options.thirdTargets" :value="item.id" :key="item.id + key">{{ item.name }}
        </iv-option>
      </iv-select>
    </div>

    <iv-card class="adm-checklist" dis-hover :bordered="false" v-if="isAudit">
      <span style="margin-right: 1em">已选 {{ selection.list.length }} 项目，所选项将</span>
      <span class="adm-buttons">
        <iv-button type="primary" :disabled="selection.list.length<=0" size="small" @click="reviewList('pass')">通过</iv-button>
        <iv-button type="primary" ghost size="small" v-if="selection.list.length<=0" :disabled="selection.list.length<=0">不通过</iv-button>
        <iv-poptip ref="selectionPoptipTop" v-model="selection.shonw" v-else>
          <iv-button type="primary" ghost size="small" :disabled="selection.list.length<=0">不通过</iv-button>
          <div slot="content" style="text-align: left;">
            <iv-form label-position="top">
              <iv-form-item label="审核批注（选填）">
                <iv-input type="textarea" v-model="selection.comment" />
              </iv-form-item>
              <div class="adm-buttons" style="text-align:right">
                <iv-button type="text" size="small" @click="closeSelectionPoptip('selectionPoptipTop')">
                  取消
                </iv-button>
                <iv-button type="primary" size="small" @click="reviewList('fail');closeSelectionPoptip('selectionPoptipTop')">
                  发送
                </iv-button>
              </div>
            </iv-form>
          </div>
        </iv-poptip>
      </span>
    </iv-card>
    <iv-table
      class="adm-table"
      :columns="columns"
      :loading="loader[REPORT_DATA]"
      :data="list.data"
      @on-sort-change="SortList"
      @on-selection-change="onTableSelected" />
    <iv-card class="adm-checklist" dis-hover :bordered="false" v-if="isAudit">
      <span style="margin-right: 1em">已选 {{ selection.list.length }} 项目，所选项将</span>
      <span class="adm-buttons">
        <iv-button type="primary" :disabled="selection.list.length<=0" size="small" @click="reviewList('pass')">通过</iv-button>
        <iv-button type="primary" ghost size="small" v-if="selection.list.length<=0" :disabled="selection.list.length<=0">不通过</iv-button>
        <iv-poptip ref="selectionPoptipDown" v-model="selection.shonw2" v-else>
          <iv-button type="primary" ghost size="small" :disabled="selection.list.length<=0">不通过</iv-button>
          <div slot="content" style="text-align: left;">
            <iv-form label-position="top">
              <iv-form-item label="审核批注（选填）">
                <iv-input type="textarea" v-model="selection.comment" />
              </iv-form-item>
              <div class="adm-buttons" style="text-align:right">
                <iv-button type="text" size="small" @click="closeSelectionPoptip('selectionPoptipDown')">
                  取消
                </iv-button>
                <iv-button type="primary" size="small" @click="reviewList('fail');closeSelectionPoptip('selectionPoptipDown')">
                  发送
                </iv-button>
              </div>
            </iv-form>
          </div>
        </iv-poptip>
      </span>
    </iv-card>
    <template v-if="list.last_page > 1">
      <div slot="footer" class="pull-right">
        <iv-page @on-change="pageChanged" :current="list.current_page" :page-size="10" show-elevator show-total :total="list.total"> </iv-page>
      </div>
    </template>
    <div slot="footer" style="line-height:3">备注：若修改更新数据，需等1-2分钟生效</div>
    <ReportDataModal :title="editModel.title" :type="editModel.type" :value="editModel.reportData" :shown="editModel.shown" @refresh="refresh" @shown-changed="editModel.shown = $event" />
    <CarbonTargetDataDeliveryModal :shown="deliveryModel.shown" @shown-changed="deliveryModel.shown = $event" />
    <CarbonAuditBatchTargetDataModal title="批量终审操作" type="audit" :shown="auditBatchTargetModal.shown" @shown-changed="auditBatchTargetModal.shown=$event" />
    <router-view />
  </AdmPanel>
</template>
<script>
import ReportDataModal from "@/components/ReportDataModal";
import CarbonTargetDataDeliveryModal from "@/components/CarbonTargetDataDeliveryModal";
import CarbonAuditBatchTargetDataModal from "@/components/CarbonAuditBatchTargetDataModal";

import ModelMixin from "@/mixins/Model.mixin";
import StatusMixin from "@/mixins/Status.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";

import contact from "@/utils/contact";
import { conditioner, defaultVal, getProductYear, carbon_years, downloadByUrl } from "@/utils/";
import Fecha from "@/utils/type/Fecha";

import FilterBar from "@/components/FilterBar_X2";
import ReportDataModel from "@/models/ReportDataModel";
import CarbonIndustryModel from "@/models/CarbonIndustryModel";
import CarbonCompanyModel from "@/models/CarbonCompanyModel";
import CarbonTargetModel from "@/models/CarbonTargetModel";
import AuditModel from "@/models/AuditModel";
import CarbonTargetDataModel from "@/models/CarbonTargetDataModel";

const COMPANY = CarbonCompanyModel.ModelName;
const REPORT_DATA = ReportDataModel.ModelName;
const TARGET = CarbonTargetModel.ModelName; // remove '$'
const ADUIT = AuditModel.ModelName;
const TARGET_DATA = CarbonTargetDataModel.ModelName;
const INDUSTRY = CarbonIndustryModel.ModelName;

const options = {
  targetType: [
    { id: "0", name: "定量" },
    { id: "1", name: "定性" }
  ],
  inputTab: [
    { id: "0", name: "录入情况不限" },
    { id: "1", name: "未录入" },
    { id: "2", name: "无报告指标" },
    { id: "4", name: "已录入" }
  ],
  sourceTypes: {
    "0": "年报",
    "1": "社报",
    "3": "外部来源"
  },
  abnormalTags: [
    // {id: '1', name: '不限'}, // API = ''
    { id: "0", name: "正常" }, // API = 0
    { id: "1", name: "异常" } // API = '1'
  ],
  audit: [
    { id: "", name: "不限" },
    { id: "1", name: "待审核" },
    { id: "2", name: "不通过" },
    { id: "3", name: "通过" }
  ],
  inputSource: [
    { id: "0", name: "年报" },
    { id: "1", name: "社报" },
    { id: "3", name: "外部数据" }
  ],
  inputTag: [
    { id: "0", name: "不限" },
    { id: "1", name: "未录入" },
    { id: "2", name: "无报告值" },
    { id: "3", name: "已录入" },
  ],
};
const _conditioner = conditioner(
  {
    //ui to url
    limit: { type: Number, default: 10 },
    year: { type: Number, default: "" },
    industryId: { type: Number, default: "" },
    stockCode: { type: String, default: "" },
    abnormalTag: { type: String, default: "" },
    // abnormalTag    : {
    //     type      : (val) => {
    //         return ['', '0', '1'][['1', '2', '3'].indexOf(val)]
    //         //return val
    //     }, default: ''
    // }, //see abnormalTags
    firstTargetNum: { type: String, default: "" },
    secondTargetNum: { type: String, default: "" },
    thirdTargetNum: { type: String, default: "" },
    timestamp: { type: val => new Date().getTime(), default: () => new Date().getTime() },
    audit: { type: Number, default: "" },
    inputTag: { type: Number, default: null },
    inputSource: { type: String, default: "" }
    // _searchby        : {type: String, default: "industryId"}
  },
  {
    // url to ui
    limit: { type: Number, default: 10 },
    year: { type: Number, default: "" },
    industryId: { type: Number, default: "" },
    stockCode: { type: String, default: "" },
    abnormalTag: { type: String, default: "" },
    // abnormalTag    : {
    //     type      : (val) => {
    //         return ['1', '2', '3'][['', '0', '1'].indexOf(val)]
    //     }, default: null
    // },
    firstTargetNum: { type: String, default: "" },
    secondTargetNum: { type: String, default: "" },
    thirdTargetNum: { type: String, default: "" },
    audit: { type: String, default: "" },
    inputTag: { type: String, default: "" },
    inputSource: { type: String, default: "" }
    // _searchby        : {type: String, default: "industryId"}
  }
);

function columns(vm) {
  const allowControl = vm.$rbac.allow(["carbonTarget", "edit"]);
  const allowLog = vm.$rbac.allow('operationLog');
  const isAudit = vm.$route.matched.some(item => item.name == "audit")
  const columns = [
    {
      title: "企业名称",
      key: "abbreviation",
      align: "center",
      width: 85
    },
    {
      title: "一级指标",
      key: "firstTargetName",
      align: "center",
      width: 85
    },
    {
      title: "二级指标",
      key: "secondTargetName",
      align: "center",
      width: 120
    },
    {
      title: "三级指标",
      key: "thirdTargetName",
      align: "center",
      width: 120
    },
    {
      title: "指标权重",
      key: "targetUnit",
      align: "center",
      width: 90,
      render(h, params) {
        const item = params.row;
        return (
          <iv-poptip trigger="click">
            <span>{item.targetWeight}</span>
            <a href="javascript:;" style="margin-left:.625em">
              <iv-icon type="md-alert" />
            </a>
            <div slot="content" class="adm-article text-left" style="max-width:200px; white-space: normal;word-break: break-all;">
              <h5>指标说明</h5>
              <div class="adm-info">
                <p domPropsInnerHTML={(item.targetRuleExplain||"").replace(/\n/g, "<br>") || "无"}></p>
              </div>
            </div>
          </iv-poptip>
        );
      }
    },
    {
      title: "报告值",
      key: "value",
      align: "center",
      minWidth: 90,
      // sortable: true,
      // sortMethod: function(a, b, type) {},
      render(h, params) {
        const item = params.row;

        return <iv-poptip trigger="hover" transfer placement="top">
            <div style="display: -webkit-box;overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp: 3;-webkit-box-orient: vertical;line-height: 1.5;max-height: 4.5em;">{item.value || ""}</div>
            <div slot="content" class="adm-article text-left" style="max-width:200px; white-space: normal;word-break: break-all;">
                <h4 slot="title">报告值</h4>
                {item.value || ""}
            </div>
          </iv-poptip>
      }
    },
    // {
    //   title: "报告值来源",
    //   key: "inputSource",
    //   align: "center",
    //   width: 100,
    //   render(h, params) {
    //     const item = params.row;
    //     return <span>{["年报", "社报", "外部数据"][[0, 1, 3].indexOf(item.inputSource)] || ""}</span>;
    //   }
    // },
    {
      title: "去年报告值",
      key: "lastValue",
      align: "center",
      width: 100,
      render(h, params) {
        const item = params.row;
        return <iv-poptip trigger="hover" transfer placement="top">
            <div style="display: -webkit-box;overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp: 3;-webkit-box-orient: vertical;line-height: 1.5;max-height: 4.5em;">{item.lastValue || ""}</div>
            <div slot="content" class="adm-article text-left" style="max-width:200px; white-space: normal;word-break: break-all;">
                <h4 slot="title">去年报告值</h4>
                {item.lastValue || ""}
            </div>
          </iv-poptip>
      }
    },
    {
      title: "异常预警",
      key: "abnormalTag",
      align: "center",
      width: 90,
      render(h, params) {
        const item = params.row;
        return <span>{item.abnormalTag}</span>;
      }
    },
    {
      title: "得分",
      key: "score",
      align: "center",
      width: 80,
      // sortable: true,
      // sortMethod: function(a, b, type) {},
      render(h, params) {
        const item = params.row;
        return <span>{item.score}</span>;
      }
    },
    {
      title: "审核状态",
      key: "score",
      align: "center",
      width: 90,
      render(h, params) {
        const item = params.row;
        if (typeof item.audit == "string") return <span>{item.audit}</span>;
        if (item.audit == "0") return "";
        const audit = options.audit.find(tag => tag.id == item.audit);
        return <span>{audit.name}</span>;
      }
    },
    // {
    //   title: "补充说明",
    //   key: "moreRemark",
    //   align: "left",
    //   width: 90,
    // },
    {
      title: "审核批注",
      key: "comment",
      align: "left",
      width: 120
    },
    {
      title: "操作",
      align: "center",
      width: isAudit||allowLog?300:130,
      render(h, params) {
        const item = {...params.row};
        item.shown = false;
        let routerLink = {
          path: "/carbon/targetData/input",
          query: {
            industryId: vm.conditions.industryId,
            year: item.year,
            stockCode: item.stockCode,
            targetSource: item.targetSource, //0-年报；1-社报；2-舆情；3-其他
            firstTargetNum: item.firstTargetNum,
            secondTargetNum: item.secondTargetNum,
            thirdTargetNum: item.thirdTargetNum,
          }
        };
        let reviewLink = {
          path: "/audit/product1/sentiment/behavior",
          query: {
            industryId: vm.conditions.industryId,
            timeScope: JSON.stringify([Fecha.format(new Date(item.year, 0, 1), "YYYY-MM-DD"), Fecha.format(new Date(parseInt(item.year) + 1, 6, 1), "YYYY-MM-DD")]),
            stockCode: item.stockCode,
            firstTargetNum: item.firstTargetNum,
            secondTargetNum: item.secondTargetNum,
            thirdTargetNum: item.thirdTargetNum
          }
        };
        // if (item.targetSource == "2") {
        //   routerLink = {
        //     path: "/sentiment/behavior",
        //     query: {
        //       industryId: vm.conditions.industryId,
        //       year: item.year,
        //       stockCode: item.stockCode,
        //       firstTargetNum: item.firstTargetNum,
        //       secondTargetNum: item.secondTargetNum,
        //       thirdTargetNum: item.thirdTargetNum
        //     }
        //   };
        // }

        const { stockCode, year, industryId, thirdTargetNum } = item
        const logData = { type:"carbonReportData", stockCode, year, industryId, thirdTargetNum }
        if (isAudit) {
          if (item.audit == "0") return "";
          // if (item.targetSource == 2)
          //   return (
          //     <adm-link-group>
          //       {" "}
          //       <router-link target="_blank" to={reviewLink}>
          //         跳转审核
          //       </router-link>
          //     </adm-link-group>
          //   );
          const send = () => {
            vm.review("fail", item);
            $poptip.componentInstance.visible = false
          };
          const $btnAuditFail = <a href="javascript:;" href="javascript:;" disabled={item.audit == "2"}>不通过</a>
          const $poptip = (
            <iv-poptip value={item.shown} transfer onInput={val => (item.shown = val)}>
              { $btnAuditFail }
              <div slot="content" style="text-align: left;">
                <iv-form label-position="top">
                  <iv-form-item label="审核批注（选填）">
                    <iv-input type="textarea" onInput={ val=>item.comment=val } />
                  </iv-form-item>
                  <div class="adm-buttons" style="text-align:right">
                    <iv-button type="text" size="small" onClick={() => ($poptip.componentInstance.visible = false)}>
                      取消
                    </iv-button>
                    <iv-button type="primary" size="small" onClick={() => send()}>
                      发送
                    </iv-button>
                  </div>
                </iv-form>
              </div>
            </iv-poptip>
          );
          return (
            <adm-link-group>
              { allowLog ? <a href="javascript:;" onClick={ ()=>vm.$operationLog.show(logData) }>查看日志</a> : "" }
              <a href="javascript:;"  disabled={item.audit == "3"} onClick={() => vm.review("pass", item)}>
                通过
              </a>
              { item.audit == "2" ? $btnAuditFail : $poptip }
            </adm-link-group>
          );
        } else {
          // disabled={item.targetSource == "2" || item.audit == "3"}
          const edit = (
            <a href="javascript:;"  onClick={() => vm.edit(item)}>
              编辑
            </a>
          );
          let query = { year:item.year, industryId:vm.conditions.industryId, thirdTargetNum:item.thirdTargetNum }
          const exportMiddleData = (
            <a href="javascript:;" onClick={ ()=>vm.exportMiddleData(query) }>导出计算日志</a>
          )
          return (
            <adm-link-group>
              {allowControl ? edit : ""}
              <router-link target="_blank" to={routerLink}>
                跳转录入
              </router-link>
              { allowLog ? <a href="javascript:;" onClick={ ()=>vm.$operationLog.show(logData) }>查看日志</a> : "" }
              { exportMiddleData }
            </adm-link-group>
          );
        }
      }
    }
  ];
  if(isAudit){
    columns.unshift({
        type: 'selection',
        width: 60,
        align: 'center'
    })
  }
  return columns;
}

const filter_rules = [
  { name: "year", type: "Select", options: [], title: "年份", default: "", placeholder: "年份", style: { width: "70px" } },
  { name: "industryId", type: "Select", options: [], title: "行业", default: "", placeholder: "行业", style: { width: "70px" } },
  { name: "stockCode", type: "Select", options: [], title: "公司", default: "", placeholder: "公司", filterable: true, clearable: true, style: { width: "145px" } },
  // {name: 'firstTargetNum', type: "Select", filterable:true, clearable:true, options: [], title: '一级指标', default: "", placeholder: "一级指标",style: { width: "150px" }},
  // {name: 'secondTargetNum', type: "Select", filterable:true, clearable:true, options: [], title: '二级指标', default: "", placeholder: "二级指标",style: { width: "150px" }},
  { name: "abnormalTag", type: "Select", clearable: true, options: options.abnormalTags, title: "异常预警", default: "1", placeholder: "异常预警", style: { width: "85px" } }, //see abnormalTags
  { name: "audit", type: "Select", options: options.audit, title: "审核状态", default: "", placeholder: "审核状态", style: { width: "85px" } }, //see abnormalTags
  { name: "inputTag", type: "Select", options: options.inputTag, title: "录入状态", default: "", placeholder: "录入状态", style:
  {
  width: "85px" } }, //see abnormalTags
  { name: "inputSource", type: "Select", options: options.inputSource, title: "数据来源", default: "", placeholder: "数据来源", clearable: true, style: { width: "85px" } } //see abnormalTags
];

const _years = carbon_years().map(year => ({ ...year, title: year.name }));

export default {
  name: "TargetDataManager",
  mixins: [
    LoaderMixin(REPORT_DATA, COMPANY, TARGET_DATA, INDUSTRY),
    StatusMixin("poptip")([{ name: "shown", default: false }]),
    ModelMixin({
      contact,
      models: [CarbonCompanyModel, ReportDataModel, CarbonTargetModel, AuditModel, CarbonTargetDataModel, CarbonIndustryModel]
    })
  ],
  data() {
    return {
      columns: columns(this),
      conditions: _conditioner.default(),
      // ModelName,
      REPORT_DATA,
      ADUIT,
      TARGET_DATA,
      INDUSTRY,
      // TARGET,
      list: {
        data: [],
        last_page: 0,
        current_page: 1
      },
      options: {
        ...options,
        year: [],
        industry: [],
        companys: [],
        firstTargets:[],
        secondTargets:[],
        thirdTargets:[],
        filter_rules
      },
      editModel: {
        shown: false,
        reportData: null,
        type: "carbon",
        title: ""
      },
      deliveryModel: {
        shown: false,
      },
      auditBatchTargetModal:{
        shown: false,
      },
      selection: {
        list: [],
        comment: "",
        shown: false,
        shown2: false,
      },
    };
  },
  async mounted() {
    const { query, params } = this.$route;
    let conditions = _conditioner.serialize({ ...query, ...params }); //处理成支持UI的格式
    this.$$loading(REPORT_DATA);
   
    this.$$loaded(REPORT_DATA);
    this.renderFilterBar("year", _years)

    conditions.year = defaultVal(conditions.year, getProductYear());
    const industries = await this.refreshIndustry(conditions.year);
    this.renderFilterBar("industryId", industries);
    conditions.industryId = defaultVal(conditions.industryId, industries[0].id);

    const companys = await this.refreshCompanys(conditions.industryId);
    this.renderFilterBar("stockCode", companys);

    this.conditions = conditions;
    this.$nextTick(() => {
      this.refreshFirstTargetNum();
      this.refreshSecondTargetNum();
      this.refreshThirdTargetNum();
      this.refresh(conditions);
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.$nextTick(() => {
      const { query, params } = to;
      let conditions = {
        ..._conditioner.default(),
        ..._conditioner.serialize({ ...query, ...params }) //处理成支持UI的格式
      };
      conditions.year = defaultVal(conditions.year, new Date().getMonth() > 7 ? new Date().getFullYear() : new Date().getFullYear() - 1);
      conditions.industryId = defaultVal(conditions.industryId, this.options.industry[0].id);

      this.conditions = conditions;
      this.refreshSecondTargetNum();
      this.refreshThirdTargetNum();
      this.refresh();
    });
    next();
  },
  methods: {
    async refresh(query = this.conditions) {
      console.log(query,'query')
      this.$$loading(REPORT_DATA);
      this.list = await this.$$active(TARGET_DATA, "thirdTarget", _conditioner.parse(query));
      this.list.current_page = _conditioner.parse(query).offset ? _conditioner.parse(query).offset / _conditioner.parse(query).limit + 1 : 1;
      this.list.last_page = this.list.total / _conditioner.parse(query).limit;
      this.selection.list = []
      this.$$loaded(REPORT_DATA);
    },
    async refreshIndustry(year) {
      this.$$loading(REPORT_DATA);
      const industry = await this.$$fetch(INDUSTRY, {year:year});
      this.$$loaded(REPORT_DATA);
      if (industry) this.options.industry = industry.data.map(item => ({ ...item, name: item.industry }));
      return this.options.industry;
    },
    async refreshSecondTargetNum(query = this.conditions) {
      const SecondTargetNum = await this.$$active(TARGET, "secondTarget", {
        firstTargetList: query.firstTargetNum ? JSON.stringify([query.firstTargetNum]) : undefined,
        industryList: query.industryId ? JSON.stringify([query.industryId]) : undefined,
        year: query.year,
        limit: 9999
      });
      if (SecondTargetNum) this.options.secondTargets = SecondTargetNum.data.map(item => ({ id: item.secondTargetNum, name: item.secondTargetName }));
      return this.options.secondTargets;
    },
    async refreshThirdTargetNum(query = this.conditions) {
      const ThirdTargetNum = await this.$$active(TARGET, "thirdTarget", {
        firstTargetList: query.firstTargetNum ? JSON.stringify([query.firstTargetNum]) : undefined,
        secondTargetList: query.secondTargetNum ? JSON.stringify([query.secondTargetNum]) : undefined,
        industryList: query.industryId ? JSON.stringify([query.industryId]) : undefined,
        year: query.year,
        limit: 9999
      });
      if (ThirdTargetNum) this.options.thirdTargets = ThirdTargetNum.data.map(item => ({ id: item.thirdTargetNum,
      name: item.thirdTargetName }));
      return this.options.thirdTargets;
    },
    async refreshFirstTargetNum(params = this.$route.params) {
      const firstTarget = await this.$$active(TARGET, "firstTarget", { ...params, limit: 9999 });
      if (firstTarget) this.options.firstTargets = firstTarget.data.map(item => ({ id: item.firstTargetNum, name: item.firstTargetName }));
      return this.options.firstTargets;
    },
    async refreshCompanys(industryId) {
      const res = await this.$$fetch(COMPANY, { industryId, limit: 9999, allTab: 1 });
      return (this.options.companys = res.data.map(item => ({ id: item.stockCode, name: item.stockCode + " " + item.abbreviation })));
    },
    renderFilterBar(fieldName, val, defaults) {
      const fieldset = this.options.filter_rules.find(fieldset => fieldset.name === fieldName);
      fieldset.options = val;
    },
    SortList(val) {
      this.conditions.ordering = val.order == "normal" ? "" : val.order == "desc" ? `-${val.key}` : val.key;
      this.changeQuery();
    },
    pageChanged(page) {
      this.$router.push({ name: this.$route.name, query: { ...this.$route.query, offset: (page - 1) * _conditioner.parse(this.conditions).limit }, params: this.$route.params });
    },
    mergeQuery(query) {
      return { ...this.conditions, ...query };
    },
    changeQuery(query = this.conditions, params = this.$route.params) {
      this.$router.push({
        name: this.$route.name,
        query: { ..._conditioner.parse(query), offset: 0 },
        params: params
      });
    },
    async exportExcel(query = this.conditions) {
      // TODO: fix 这个方法变回这边的写法，支持错误捕获和提示
      // const res = await exportReportExcel({..._conditioner.parse(query)})
      const res = await this.$$active(TARGET_DATA, "export", { ..._conditioner.parse(query), type: "thirdTarget"
      });
      console.log("exportExcel...", res);
      if (!res.data.url) {
        this.$$info("后台未返回url，请重试");
        return;
      }
      // 下载链接
      downloadByUrl(res.data.url);
    },
    async exportMiddleData(item){
      // TODO: fix 这个方法变回这边的写法，支持错误捕获和提示
      // const res = await exportReportExcel({..._conditioner.parse(query)})
      const res = await this.$$active(TARGET_DATA, "export", { ...item, type:"middleData" });
      console.log("exportExcel...", res);
      if (!res.data.url) {
        this.$$info("后台未返回url，请重试");
        return;
      }
      // 下载链接
      downloadByUrl(res.data.url);
    },
    // 编辑函数
    edit(item) {
      this.editModel.shown = true;
      this.editModel.reportData = { ...item, industryId: this.conditions.industryId };
      this.editModel.title = `正在编辑 ${item.abbreviation} - ${item.thirdTargetName} 指标数据`;
    },
    async review(action_name, item) {
      const { year, industryId, stockCode, thirdTargetNum, comment } = item;
      const target = { year, industryId, stockCode, thirdTargetNum, comment, audit: 0 };
      switch (action_name) {
        case "pass":
          target.audit = 3;
          break;
        case "fail":
          target.audit = 2;
          break;
      }
      try {
        this.$$loading(ADUIT);
        await this.$$active(ADUIT, "carbonThirdTarget", target);
        this.$$loaded(ADUIT);
      } catch (e) {
        this.$$error(e);
      }
      this.refresh();
    },
    onTableSelected(selection){
      this.selection.list = selection
    },
    async reviewList(action_name, comment=this.selection.comment ,selection=this.selection.list){
      const audit = ['','','fail','pass'].indexOf(action_name)
      const items = selection.filter(item=>item.audit!=audit).map(item=>({ ...item, comment, audit }))
      this.selection.comment = ""
      if(items.length<=0){
        return this.$$error(new Error(`已选的${selection.length}项，所选项已是${['','','不通过','通过'][['','','fail','pass'].indexOf(action_name)]}状态`))
      }
      // return console.log({ comment, audit, auditList:items })
      try {
        this.$$loading(ADUIT);
        await this.$$active(ADUIT, "batchCarbonThirdTarget", { comment, audit, auditList:items });
        this.$$loaded(ADUIT);
      } catch (e) {
        this.$$error(e);
      }
      this.refresh();
    },
    closeSelectionPoptip(ref){
      this.$refs[ref].visible = false
    }
  },
  computed: {
    isAudit() {
      return this.$route.matched.some(item => item.name == "audit");
    }
  },
  watch: {
    async ["conditions.firstTargetNum"](val) {
      this.refreshSecondTargetNum();
      this.refreshThirdTargetNum();
    },
    async ["conditions.secondTargetNum"](val) {
      this.refreshThirdTargetNum();
    },
    async ["conditions.industryId"](val, oldVal) {
      if (val === oldVal) return;
      const companys = await this.refreshCompanys(val);
      this.renderFilterBar("stockCode", companys);
    },
    'conditions.year': {
      async handler (newVal, oldVal) {
        if (oldVal) {
          const industries = await this.refreshIndustry(newVal);
          this.renderFilterBar("industryId", industries);
        }
      }
    },
  },
  components: {
    FilterBar,
    ReportDataModal,
    CarbonTargetDataDeliveryModal,
    CarbonAuditBatchTargetDataModal
  }
};
</script>
